import { Modal, Skeleton } from "antd";
import { useEffect, useRef, useState } from "react";

import { useAtualizarInfoPag } from "../Hooks/useAtualizarInfoPag";
import { useNavigate } from "react-router-dom";
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";
import { useInfoPagamentoAtivo } from "../Hooks/useInfoPagamentoAtivo";
import {
  AlertTextModal,
  ContainerModal,
  TextModal,
  TextModal2,
  TitleIndex,
} from "../styles";

export default function ModalExcluir({
  isModalOpen,
  handleFechar,
  usuarioId,
}: any) {
  const { atualizar, isLoading, error, success } = useAtualizarInfoPag();

  const { isLoading: isLoadingInfo, infoPagData } =
    useInfoPagamentoAtivo(usuarioId);

  // Estado inicial de dos dados Lead que serão atualizados
  const info = { active: 0, id: infoPagData.id };
  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Sucesso
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Hook de navegação do React Router
  const navigate = useNavigate();

  const errorRef = useRef<string | null>(null);

  useEffect(() => {
    if (error) {
      errorRef.current = error;
    }
  }, [error]);

  // useEffect para lidar com o sucesso
  useEffect(() => {
    if (success && !successDisplayed) {
      // Verifica se o sucesso já foi exibido
      showSuccess(success);
      setSuccessDisplayed(true);
      setTimeout(() => {
        navigate(0); // Use navigate(0) para simular um refresh completo
      }, 3000);
    }
    if (errorRef.current && !errorDisplayed) {
      // Verifica se o erro já foi exibido
      showError(errorRef.current);
      setErrorDisplayed(true); // Marca que o erro foi exibido

      // Limpa estado de error após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        errorRef.current = null;
      }, 3000);
    }
  }, [
    success,
    showSuccess,
    successDisplayed,
    errorDisplayed,
    showError,
    navigate,
  ]);
  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Excluir"
        onOk={() => atualizar(info)}
        confirmLoading={isLoading}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        <>{errorContextHolder}</>
        <>{successContextHolder}</>
        {isLoadingInfo && <Skeleton active />}
        {!isLoadingInfo && infoPagData && (
          <>
            <TitleIndex>
              Tem certeza que deseja excluir a chave pix atual?
            </TitleIndex>
            <ContainerModal>
              {infoPagData.pix ? (
                <>
                  <TextModal2>Chave Pix atual:</TextModal2>
                  <TextModal> {infoPagData.pix}</TextModal>
                </>
              ) : (
                <AlertTextModal>Não há nenhuma chave pix ativa</AlertTextModal>
              )}
            </ContainerModal>
          </>
        )}
      </Modal>
    </>
  );
}
